function capitalize(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}

function formatClock(value) {
  const text = String(value || '').trim();
  if (!text) return '-';

  const [hoursPart, minutesPart = '00'] = text.split(':');
  const hours = Number(hoursPart);
  const minutes = Number(minutesPart);

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return text;

  const period = hours >= 12 ? 'PM' : 'AM';
  const normalizedHours = hours % 12 || 12;
  const normalizedMinutes = String(minutes).padStart(2, '0');
  return `${normalizedHours}:${normalizedMinutes} ${period}`;
}

export function buildClassAccessPath(slug, classId) {
  return `/academy/${slug}/classes/${classId}`;
}

export function formatClassSchedule(classItem = {}) {
  const startTime = formatClock(classItem.startTime);
  const endTime = formatClock(classItem.endTime);
  const recurrence = classItem.recurrence || {};
  const days = Array.isArray(recurrence.daysOfWeek) && recurrence.daysOfWeek.length
    ? recurrence.daysOfWeek.map(capitalize).join(', ')
    : 'Daily';

  if (classItem.scheduleType === 'continuous' || recurrence.frequency === 'daily' || recurrence.frequency === 'continuous') {
    return `${days} ${startTime} - ${endTime}`;
  }

  if (classItem.scheduledDate) {
    return `${classItem.scheduledDate} ${startTime} - ${endTime}`;
  }

  return `${startTime} - ${endTime}`;
}
